"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        position: 'absolute',
        top: -constants_1.FOCUS_OUTLINE_WIDTH,
        left: -constants_1.FOCUS_OUTLINE_WIDTH,
        width: `calc(100% + ${constants_1.FOCUS_OUTLINE_WIDTH * 2}px)`,
        height: 'auto',
        display: 'block',
        fill: theme.indigoPastel2,
        transform: 'scale(0.7)',
        transition: 'transform 200ms ease-in-out 0ms',
        ':focus &': {
            transform: 'scale(1)'
        }
    }
});
//# sourceMappingURL=avatar.group.outline.style.js.map